import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { SubscriptionsModalType } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";

import { GetPhoneApiResultModel, getPhoneNumberService } from "@WhiteCap/Store/Service/SubscriptionsDasboardService";

export interface GetPhoneNumberApiParameter extends ApiParameter {
    emailId?: string;
    subscriptionModalType?: SubscriptionsModalType;
    onError?: (error: string) => void;
}
type HandlerType = CustomApiHandler<GetPhoneNumberApiParameter, GetPhoneApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/SubscriptionDashboard/BeginFetchPhoneNumber",
        subscriptionModalType: props.apiParameter.subscriptionModalType,
        emailId: props.apiParameter.emailId,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getPhoneNumberService(props.apiParameter.emailId);
    if (result.successful && result.result) {
        props.apiResult = result.result;
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/SubscriptionDashboard/SoaSubscriptions/FetchPhoneNumberError",
        });
        return false;
    }
};

export const DispatchCompleteFetchPhoneNumber: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/CompleteFetchPhoneNumber",
        result: props.apiResult,
        subscriptionModalType: props.apiParameter.subscriptionModalType,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteFetchPhoneNumber];

const getPhoneNumber = createHandlerChainRunner(chain, "GetPhoneNumber");
export default getPhoneNumber;
